export default "__VITE_ASSET__C23iS0rz__"